module.exports = __webpack_public_path__ + "media/mypage/images/flat/login-a0f9f4435288d2d490333dbc2a50b90c.png";